var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import PurchaseService from '../../../api/PurchaseService';
import HeaderItem from "../../../components/HeaderItem";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplierupperOptions = [];
        _this.accountOptions = [];
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        _this.docTypeList = [
            { name: '自定义采购', value: 1 }
        ];
        _this.pickerOptions = {
            disabledDate: function (time) {
                return time.getTime() > Date.now();
            },
        };
        return _this;
    }
    default_1.prototype.watchFormDataOrganId = function (newValue, oldValue) {
        if (this.handleStatus === 2)
            return;
        if (newValue) {
            if (oldValue) {
                this.formData.depot_id = '';
                this.formData.supplier_upper_id = '';
                this.formData.purchasing_agent_id = '';
            }
            this.getSupplierdepotOptions();
            this.getSupplierupperOptions();
            this.getAccountOptions();
        }
        else {
            this.supplierdepotOptions = [];
            this.supplierupperOptions = [];
            this.accountOptions = [];
            this.formData.depot_id = '';
            this.formData.supplier_upper_id = '';
            this.formData.purchasing_agent_id = '';
        }
    };
    default_1.prototype.created = function () {
        this.purchaseService = PurchaseService.getInstance();
        if (this.handleStatus === 1) {
            this.getSupplierorganOptions();
        }
    };
    default_1.prototype.mounted = function () { };
    default_1.prototype.getSupplierupperOptions = function (val) {
        var _this = this;
        var params = {
            keyword: val || '',
            organ_id: this.formData.organ_id
        };
        this.purchaseService.getSupplierupperOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierupperOptions = res.data.data;
            }
        });
    };
    default_1.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.purchaseService.getSupplierorganOptions().then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                _this.formData.organ_id = res.data.data && res.data.data[0].organ_id || '';
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
            is_init: 1
        };
        this.purchaseService.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierdepotOptions = res.data.data;
                (res.data.data || []).some(function (item) {
                    if (item.is_organ_default == 1) {
                        _this.formData.depot_id = item.depot_id;
                        return true;
                    }
                    _this.formData.depot_id = '';
                });
            }
        });
    };
    default_1.prototype.getAccountOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id
        };
        this.purchaseService.getAccountOptions().then(function (res) {
            if (res.data.success) {
                _this.accountOptions = res.data.data;
            }
        });
    };
    default_1.prototype.filterSearch = function (val) {
        var _this = this;
        var This = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getSupplierupperOptions(val);
        }, 500);
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Prop({
            required: true,
            default: ''
        })
    ], default_1.prototype, "fromAction", void 0);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchFormDataOrganId", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
